<template>
  <Flex
    :class="[
      $style.base,
      {
        [$style.smallScreen]: $screen === 's',
        [$style.fullWidth]: fullWidth
      }
    ]"
    justify="between"
    align="center"
    :padding="$screen === 's' ? 1 : 1.5"
  >
    <div :class="$style.left">
      <BaseButton
        v-if="$screen === 's'"
        color="inverted"
        icon="more-horizontal"
        :options="buttonOptions"
        @select="handleOptionSelect"
        v-test="'register-footer-options'"
      />
    </div>
    <div :class="$style.right">
      <BaseButton
        v-if="$screen !== 's'"
        color="inverted"
        :options="buttonOptions"
        @select="handleOptionSelect"
        v-test="'register-footer-options'"
      >
        {{ $t('global.more_actions') }}
      </BaseButton>
      <Flex direction="column">
        <slot name="primaryAction" />
      </Flex>
    </div>

    <CreateNote
      v-if="showCreateNoteModal"
      :currentNote="order.note || undefined"
      @submit="order.note = $event"
      @close="showCreateNoteModal = false"
    />
  </Flex>
</template>

<script
  setup
  lang="ts"
>
import { ref } from 'vue';
import CreateNote from '@/modals/CreateNote.vue';
import { useRegisterOrderStore } from '@/modules/register/stores/order';
import { useRegisterStore } from '@/modules/register/stores/register';

const { order, reset } = useRegisterOrderStore();
const { exitCurrentState } = useRegisterStore();

const emit = defineEmits(['select']);
defineProps<{
  fullWidth?: boolean;
  buttonOptions: any[];
}>();

const showCreateNoteModal = ref(false);

const handleOptionSelect = (option: string) => {
  if (option === 'note') {
    showCreateNoteModal.value = true;
  } else if (option === 'reset') {
    exitCurrentState();
    reset();
  } else {
    emit('select', option);
  }
};
</script>

<style
  module
  lang="scss"
>
.base {
  box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.1);
  z-index: 1;
  background-color: var(--color-bg);
  
  &.smallScreen {
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
  }
}

.left,
.right {
  display: flex;
  gap: $spacing;

  .base.smallScreen & {
    &:empty {
      display: none;
    }
  }
}

.right {
  .base.smallScreen & {
    width: 100%;
    justify-content: flex-end;
  }

  & > * {
    .base.smallScreen & {
      flex-shrink: 1;
    }

    .base.smallScreen.fullWidth & {
      width: 100%;
    }
  }
}
</style>
